import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminLayout from './components/layout/AdminLayout';
import Dashboard from './pages/Dashboard';
import Templates from './pages/Templates';
import TemplateEditor from './pages/TemplateEditor';
import Newsletters from './pages/Newsletters';
import NewsletterEditor from './pages/NewsletterEditor';
import Recipients from './pages/Recipients';
import Settings from './pages/Settings';
export function App() {
  return <Routes data-id="element-0">
      <Route path="/" element={<AdminLayout data-id="element-2" />} data-id="element-1">
        <Route index element={<Dashboard data-id="element-4" />} data-id="element-3" />
        <Route path="templates" element={<Templates data-id="element-6" />} data-id="element-5" />
        <Route path="templates/create" element={<TemplateEditor data-id="element-8" />} data-id="element-7" />
        <Route path="templates/edit/:id" element={<TemplateEditor data-id="element-10" />} data-id="element-9" />
        <Route path="newsletters" element={<Newsletters data-id="element-12" />} data-id="element-11" />
        <Route path="newsletters/create" element={<NewsletterEditor data-id="element-14" />} data-id="element-13" />
        <Route path="newsletters/edit/:id" element={<NewsletterEditor data-id="element-16" />} data-id="element-15" />
        <Route path="recipients" element={<Recipients data-id="element-18" />} data-id="element-17" />
        <Route path="settings" element={<Settings data-id="element-20" />} data-id="element-19" />
      </Route>
    </Routes>;
}